import { InstructionTabItem, InstructionTab } from '../types';

export const instructionTabs: InstructionTabItem[] = [
  { id: InstructionTab.Interface, label: 'Подача сигналов через интерфейс' },
  { id: InstructionTab.Api, label: 'Подача сигналов через API' },
  { id: InstructionTab.Faq, label: 'FAQ' },
];
